import { render, staticRenderFns } from "./input_auth.vue?vue&type=template&id=8fc6c976&lang=pug&"
import script from "./input_auth.vue?vue&type=script&lang=js&"
export * from "./input_auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports